module.exports = __webpack_public_path__ + "media/images/big-profile-5c94059778b3c4986b39c38f4c55ebd1.png";